import styles from './DashboardError.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { ErrorIcon } from 'seek-style-guide/react';
import { retry } from 'store/dashboard/dashboard';

const mapDispatchToProps = dispatch => ({
  retryHandler: () => dispatch(retry())
});

@connect(null, mapDispatchToProps)
class DashboardError extends Component {

  static propTypes = {
    message: PropTypes.string,
    retryHandler: PropTypes.func
  };

  static defaultProps = {
    message: '',
    retryHandler: () => {}
  };

  render() {
    const { message, retryHandler } = this.props;

    return (
      <div className={styles.root} data-automation="dashboardError">
        <div className={styles.messageContainer}>
          <ErrorIcon svgClassName={styles.errorSvg} />
          <p className={styles.text}>
            { message }
            <span className={styles.retry} onClick={retryHandler}>Try again</span>
          </p>
        </div>
      </div>
    );
  }

}

export default DashboardError;



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardError/DashboardError.js
 **/